import { Menu } from '../Menu';

export const DropdownMenuItem: typeof Menu.Item = Menu.Item;
